import { FC } from 'react';

export type LogoProps = { width?: string | number; height?: string | number };

export const Logo: FC<LogoProps> = ({ width, height }) => (
  <svg
    version="1.1"
    id="svg2"
    width={width}
    height={height}
    viewBox="0 0 2425.6001 453.21332"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="logo"
  >
    <g id="g8" transform="matrix(1.3333333,0,0,-1.3333333,0,453.21333)">
      <g id="g10" transform="scale(0.1)">
        <path
          d="M 7177.63,2967.28 5737.27,39.5117 h 552.1 L 6621.55,747.73 h 1264.31 l 75.95,-708.2183 h 588.12 L 8153.97,2967.28 Z m 460.12,-47.45 h 8.04 L 7837.8,1171.11 H 6817.54 l 820.21,1748.72"
          style={{
            fill: '#233743',
            fillOpacity: 1,
            fillRule: 'nonzero',
            stroke: 'none',
          }}
          id="path12"
        />
        <path
          d="M 9256.75,2967.28 8733.91,39.5117 h 528.18 L 9784.92,2967.28 h -528.17"
          style={{
            fill: '#233743',
            fillOpacity: 1,
            fillRule: 'nonzero',
            stroke: 'none',
          }}
          id="path14"
        />
        <path
          d="M 10200.9,2967.28 9678.14,39.5117 h 528.06 l 522.9,2927.7683 h -528.2"
          style={{
            fill: '#233743',
            fillOpacity: 1,
            fillRule: 'nonzero',
            stroke: 'none',
          }}
          id="path16"
        />
        <path
          d="m 11141.7,2967.35 -84,-494.56 h 528.1 l 84.1,494.56 z M 10989.3,2085.63 10620.2,39.1289 h 528 l 369.3,2046.5011 h -528.2"
          style={{
            fill: '#233743',
            fillOpacity: 1,
            fillRule: 'nonzero',
            stroke: 'none',
          }}
          id="path18"
        />
        <path
          d="m 11618.4,830.852 c 0,743.768 488.2,1234.378 1244.3,1234.378 524.2,0 828.3,-284.83 844.3,-775.44 h -520.2 c -23.9,229.5 -160,363.96 -396,363.96 -380.1,0 -624.2,-316.44 -624.2,-767.488 0,-292.793 140.1,-470.832 404.1,-470.832 244.1,0 432.2,142.41 540.2,387.761 H 13631 C 13462.9,292.719 13050.8,0 12494.7,0 c -564.1,0 -876.3,308.559 -876.3,830.852"
          style={{
            fill: '#233743',
            fillOpacity: 1,
            fillRule: 'nonzero',
            stroke: 'none',
          }}
          id="path20"
        />
        <path
          d="m 13814.9,830.852 c 0,747.708 492.1,1234.378 1252.4,1234.378 568.1,0 884.2,-308.63 884.2,-826.91 C 15951.5,490.609 15467.4,0 14699.1,0 14135,0 13814.9,308.559 13814.9,830.852 m 1592.4,348.128 c 0,296.73 -143.9,474.77 -412.1,474.77 -384,0 -632.1,-312.5 -632.1,-763.551 0,-296.73 144,-474.769 412.1,-474.769 388.1,0 632.1,308.562 632.1,763.55"
          style={{
            fill: '#233743',
            fillOpacity: 1,
            fillRule: 'nonzero',
            stroke: 'none',
          }}
          id="path22"
        />
        <path
          d="m 18192,1475.74 c 0,-71.25 -8,-146.43 -20.1,-225.49 l -216,-1210.7305 h -528.2 l 212.2,1186.9305 c 7.9,39.57 11.9,79.13 11.9,110.81 0,201.77 -120,316.52 -328,316.52 -280.2,0 -480.2,-201.77 -540.2,-538.06 l -192,-1076.2005 h -528.1 L 16419.6,2025.7 h 528.1 l -128.1,-696.39 h 8 c 84,462.94 376.1,735.95 784.2,735.95 376.1,0 580.2,-213.66 580.2,-589.52"
          style={{
            fill: '#233743',
            fillOpacity: 1,
            fillRule: 'nonzero',
            stroke: 'none',
          }}
          id="path24"
        />
        <path
          d="M 2690.12,1213.59 1832.23,37.8789 H 4819.22 L 4471.31,1213.59 H 2690.12"
          style={{
            fill: '#233743',
            fillOpacity: 1,
            fillRule: 'nonzero',
            stroke: 'none',
          }}
          id="path26"
        />
        <path
          d="M 0,37.8594 H 1469.77 L 2759.26,1798.62 2338.18,3227.48 0,37.8594"
          style={{
            fill: '#233743',
            fillOpacity: 1,
            fillRule: 'nonzero',
            stroke: 'none',
          }}
          id="path28"
        />
        <path
          d="M 2589.06,3399.06 3149.8,1499.37 H 4385.75 L 3824.71,3399.06 H 2589.06"
          style={{
            fill: '#233743',
            fillOpacity: 1,
            fillRule: 'nonzero',
            stroke: 'none',
          }}
          id="path30"
        />
      </g>
    </g>
  </svg>
);
